import { render, staticRenderFns } from "./SubscriptionsView.vue?vue&type=template&id=03154ad8&scoped=true&"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsView.vue?vue&type=style&index=0&id=03154ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03154ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03154ad8')) {
      api.createRecord('03154ad8', component.options)
    } else {
      api.reload('03154ad8', component.options)
    }
    module.hot.accept("./SubscriptionsView.vue?vue&type=template&id=03154ad8&scoped=true&", function () {
      api.rerender('03154ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/SubscriptionsView.vue"
export default component.exports